import React from 'react'
import styled from '@emotion/styled'

import { fontWeightBold, fontFamilyOpenSans, highlightBlueBase } from '../../constants/principles'

export default ({ name, phone }) => (
  <>
    <StyledH3>{!!name && 'Redeem Your Offer At:'}</StyledH3>
    <StyledH3 data-testid={'bi-text-dealer-name'}>{name}</StyledH3>
    <StyledA data-testid={'bi-text-dealer-phone'} href={`tel:${phone}`}>{phone}</StyledA>
  </>
)

const StyledH3 = styled.h3`
  font-weight: inherit;
  margin: 0px;
  text-align: center;
`

const StyledA = styled.a`
  font-family: ${fontFamilyOpenSans};
  font-weight: ${fontWeightBold};
  color: ${highlightBlueBase};
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 8px;
  :hover {
    text-decoration: underline;
  }
`
